export const LOGOS = [
    {
        src: "https://monsterocu-prod-publicfiles.s3.eu-central-1.amazonaws.com/shipprotect-main.png"
    },
    {
        src: "https://monsterocu-prod-publicfiles.s3.eu-central-1.amazonaws.com/monster-protect-1.png"
    },
    {
        src: "https://monsterocu-prod-publicfiles.s3.eu-central-1.amazonaws.com/monster-protect-2.png"
    },
    // {
    //     src: "https://monsterocu-prod-publicfiles.s3.eu-central-1.amazonaws.com/monster-protect-3.png"
    // },
    // {
    //     src: "https://monsterocu-prod-publicfiles.s3.eu-central-1.amazonaws.com/monster-protect-4.png"
    // }
]